import React from "react";
import styled from "styled-components";
import { colorAttentionBlue10, colorAttentionBlue50, spacingXxs, spacingS, spacingL, IconChevronRight, } from "@rhumbix/rmbx_design_system_design_tokens";
const NavArrows = ({ className, leftAction, rightAction }) => (React.createElement(Container, { className: className },
    React.createElement(IconChevronRight, { className: "left-arrow", onClick: () => leftAction() }),
    React.createElement(IconChevronRight, { className: "right-arrow", onClick: () => rightAction() })));
const Container = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .left-arrow {
        width: ${spacingL};
        height: ${spacingL};
        padding: ${spacingS};
        margin-right: ${spacingS};
        transform: rotate(180deg);
        color: ${colorAttentionBlue50};
        background-color: ${colorAttentionBlue10};
        border-radius: ${spacingXxs};

        &:hover {
            cursor: pointer;
        }
    }

    .right-arrow {
        height: ${spacingL};
        width: ${spacingL};
        padding: ${spacingS};
        color: ${colorAttentionBlue50};
        background-color: ${colorAttentionBlue10};
        border-radius: ${spacingXxs};

        &:hover {
            cursor: pointer;
        }
    }
`;
export default NavArrows;
